function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot';
import { ComponentBootstrap, withReactBootstrap } from '@demant/react-bootstrap';
import PreElementFilter from './pre-element-filter';
var EVERYTHING = 'everything';

var FlexSpotCards = function FlexSpotCards(_ref) {
  var settings = _ref.settings,
      isDesktop = _ref.isDesktop,
      component = _ref.component;
  var keyCounter = 0;

  var _useState = useState(EVERYTHING),
      _useState2 = _slicedToArray(_useState, 2),
      filterValue = _useState2[0],
      setFilterValue = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollPos = _useState4[0],
      setScrollPos = _useState4[1];

  var _useState5 = useState(10),
      _useState6 = _slicedToArray(_useState5, 2),
      maxScroll = _useState6[0],
      setMaxScroll = _useState6[1];

  var preElementItems = settings.preElementItems || [];
  var preElementTags = settings.preElementTags || [];
  var elementItems = settings.elements || [];
  var postElementItems = settings.postElementItems || [];
  var hasFilters = settings.preElementItems.filter(function (item) {
    return item.type === 'link';
  }).length > 1;
  useEffect(function () {
    preElementItems.forEach(function (preElementItem) {
      if (preElementItem.tag && preElementItem.tag.includes('background')) {
        return component.style.backgroundImage = "url(".concat(preElementItem.image.src, ")");
      }
    });
  }, []);
  var filteredElements = elementItems.filter(function (element) {
    if (filterValue.toLowerCase() === EVERYTHING) {
      return true;
    }

    var tags = element.tags.map(function (tag) {
      return tag.toLowerCase();
    });

    if (hasFilters) {
      if (tags.indexOf(filterValue.toLowerCase()) > -1) {
        return true;
      }

      return false;
    }

    return true;
  });

  var handleClick = function handleClick(e) {
    var href = e.target.href.toString().substr(e.target.href.toString().indexOf('#') + 1);
    setFilterValue(href);
  };

  var preElementWrapper = document.querySelector('.pre-element-wrapper');

  var handleHorizontalScroll = function handleHorizontalScroll() {
    if (preElementWrapper) {
      setScrollPos(preElementWrapper.scrollLeft);
      setMaxScroll(preElementWrapper.scrollWidth - preElementWrapper.clientWidth);
    }
  };

  var handleClickRight = function handleClickRight() {
    setScrollPos(preElementWrapper.scrollLeft += 100);
  };

  var handleClickLeft = function handleClickLeft() {
    setScrollPos(preElementWrapper.scrollLeft -= 100);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, preElementItems.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, preElementTags.includes('filter') ? /*#__PURE__*/React.createElement(PreElementFilter, {
    settings: settings,
    isDesktop: isDesktop,
    maxScroll: maxScroll,
    scrollPos: scrollPos,
    tags: preElementTags,
    handleClick: handleClick,
    handleHorizontalScroll: handleHorizontalScroll,
    handleClickRight: handleClickRight,
    handleClickLeft: handleClickLeft
  }) : /*#__PURE__*/React.createElement("div", {
    className: "pre-element"
  }, preElementItems.map(function (preElement) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pre-element__item",
      key: keyCounter++
    }, preElement.type === 'text' && /*#__PURE__*/React.createElement("div", {
      className: "pre-element__item__text",
      dangerouslySetInnerHTML: {
        __html: preElement.html.html
      }
    }), preElement.link && preElement.link.href && preElement.type === 'link' && /*#__PURE__*/React.createElement("div", {
      className: "pre-element__item__link"
    }, /*#__PURE__*/React.createElement("a", {
      href: preElement.link.href && preElement.link.href
    }, preElement.link.content)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "element-wrapper"
  }, filteredElements.map(function (elementItem) {
    return /*#__PURE__*/React.createElement("div", {
      className: "element",
      "data-tag": elementItem.tags,
      key: keyCounter++
    }, elementItem.items.map(function (item) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: keyCounter++
      }, item.type === 'image' && /*#__PURE__*/React.createElement("div", {
        className: "element__item element__item__image"
      }, /*#__PURE__*/React.createElement("img", {
        src: item.image.src,
        alt: item.image.alt
      })), item.type === 'text' && /*#__PURE__*/React.createElement("div", {
        className: "element__item element__item__text",
        dangerouslySetInnerHTML: {
          __html: item.html.html
        }
      }), item.type === 'link' && /*#__PURE__*/React.createElement("div", {
        className: "element__item element__item__link",
        dangerouslySetInnerHTML: {
          __html: item.html.html
        }
      }), item.type === 'video' && /*#__PURE__*/React.createElement("div", {
        className: "element__item element__item__video"
      }, /*#__PURE__*/React.createElement("iframe", {
        src: item.video.src
      })));
    }));
  })), postElementItems.map(function (postElement) {
    return /*#__PURE__*/React.createElement("div", {
      className: "post-element",
      key: keyCounter++
    }, postElement.type === 'text' && /*#__PURE__*/React.createElement("div", {
      className: "post-element__item post-element__item__text",
      dangerouslySetInnerHTML: {
        __html: postElement.html.html
      }
    }));
  }));
};

var ReactFlexSpotCards = new ComponentBootstrap('flex-spot.cards');
ReactFlexSpotCards.schemaData = flexSpotSchema;
ReactFlexSpotCards.reactApp = withReactBootstrap(FlexSpotCards);
ReactFlexSpotCards.run();